import { useQuery } from '@tanstack/react-query';

import { getAccountingPeriodById } from './accountingPeriod';
import type { AccountingPeriod } from './accountingPeriod.types';
import { ACCOUNTING_PERIODS_KEY } from './constants';

export const useGetAccountingPeriodById = (id?: number) => {
  return useQuery<AccountingPeriod>({
    queryKey: [ACCOUNTING_PERIODS_KEY, 'byId', id],
    queryFn: () => {
      if (!id) {
        throw new Error('ID is required to fetch accounting period');
      }
      return getAccountingPeriodById(id);
    },
    enabled: !!id, // Only run query if id is provided
  });
};
